// Third-party
import React, { ReactElement } from 'react';

// Components
import { ControlItem, SegmentedControl } from '@/views/components/navigation';
import { FormattedMessageV2 } from '@/views/components/i18n';

// Enums
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

// Types
import { DataSourceTabs as DataSourceTabsType } from '@/types/app-config';

type Props = {
  dark?: boolean;
  disabled?: boolean;
  value: string;
  tabs: DataSourceTabsType[];
  onChange: (value: string) => void;
};

const LegacyDataSourceTabs = ({ dark, disabled, tabs, value, onChange }: Props): ReactElement => (
  <SegmentedControl disabled={disabled} className="data-source-tabs blue-selection" tabStyle dark={dark} onChange={onChange} selected={value}>
    {tabs.map(tab => (
      <ControlItem key={tab.value} value={tab.value}>
        <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.SPAN} toLocalize={tab.label} />
      </ControlItem>
    ))}
  </SegmentedControl>
);

export default LegacyDataSourceTabs;
